import { BootstrapTooltip } from './BootstrapTooltip'
import { getAccessibleUnavailableProps } from 'utils/reportDisabledFields'
import { ReactNode } from 'react'

interface UnavailableValueProps {
  children?: ReactNode
  message: string
}

export const UnavailableValue = ({ children = '-', message }: UnavailableValueProps) => (
  <BootstrapTooltip title={message}>
    <span {...getAccessibleUnavailableProps(message)} tabIndex={0}>{children}</span>
  </BootstrapTooltip>
)
